import React from "react";

import { StyledTypography, StyledTypographyProps } from "./styled";

type TypographyProps = {
  className?: string;
  text: string;
  key?: string | number;
  NotNewLined?: boolean;
} & StyledTypographyProps;

export const Typography: React.FC<TypographyProps> = ({
  text,
  NotNewLined,
  ...rest
}) => {
  const replaced = text.replaceAll(/¥n/g, "\\n");
  const splited = replaced.split("\\n");
  const newLlined = splited.reduce((current, next) => `${current}\n${next}`);

  return (
    <StyledTypography {...rest}>
      {NotNewLined ? text : newLlined}
    </StyledTypography>
  );
};
